export enum CancellationRateStatus {
  BAD = 0,
  MEDIUM = 1,
  GOOD = 2,
}
